import api from ".";

const ingredientPath = "/api/ingredients";

export const formatIngredients = async (ingredients, token) => {
  try {
    const headers = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    const { data } = await api.post(
      `${ingredientPath}/format`,
      { ingredients },
      {
        headers: {
          ...headers,
        },
      }
    );

    return data;
  } catch (error) {
    console.error("Ingredient Format API Error:", {
      message: error.message,
      status: error.response?.status,
      data: error.response?.data,
    });

    throw (
      error.response?.data || {
        success: false,
        message: "Ingredient formatting failed",
      }
    );
  }
};